import { AddCircle } from '@material-ui/icons';
import { Button, Collapse } from '@mui/material';
import * as React from 'react';
import { toast } from 'react-toastify';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import TopPage from 'v2/components/Shared/TopPage';

import WebhookContext from './context';
import { List } from './List';
import webhookService from './service';
import styles from './styles';
import WebhookForm from './WebhookForm';

import type { Webhook, WebhookFilter } from './interfaces';

const WEBHOOK_DOCUMENTATION_URL = 'https://github.com/eduzz/webhook/tree/master/v2';

export default function Webhook2() {
  const classes = styles();
  const [loading, setLoading] = React.useState<boolean>();
  const [webhooks, setWebhooks] = React.useState<Webhook[]>([]);
  const [selectedWebhook, setSelectedWebhook] = React.useState<Webhook>();
  const [isFormOpen, setIsFormOpen] = React.useState<boolean>(false);
  const [isActionsOpen, setIsActionsOpen] = React.useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement>();
  const [expanded, setExpanded] = React.useState<number>(-1);
  const [filter, setFilter] = React.useState<WebhookFilter>({ type: 'all', status: 'all' });

  const listWebhooks = async () => {
    try {
      setLoading(true);
      const webhooks = await webhookService.list();
      setWebhooks(webhooks);
      setLoading(false);
    } catch (e) {
      toast.error('Ocorreu um erro ao tentar carregar webhooks');
      setLoading(false);
    }
  };

  const isCollapseExpanded = expanded !== -1;
  return (
    <WebhookContext.Provider
      value={{
        loading,
        webhooks,
        selectedWebhook,
        isFormOpen,
        isActionsOpen,
        anchorEl,
        expanded,
        filter,
        setAnchorEl,
        setExpanded,
        setFilter,
        setSelectedWebhook,
        setIsActionsOpen,
        setIsFormOpen,
        listWebhooks,
        setLoading,
      }}
    >
      <Collapse in={!isCollapseExpanded}>
        <TopPage
          title='Webhooks'
          action={
            <>
              <Button href={WEBHOOK_DOCUMENTATION_URL} target='_blank' className={classes.documentationButton} variant='outlined'>
                Documentação
              </Button>
              <PermissionHide action={'myeduzz:webhook:criar'}>
                <Button disabled={loading} startIcon={<AddCircle />} variant='contained' onClick={() => setIsFormOpen(true)}>
                  Novo webhook
                </Button>
              </PermissionHide>
            </>
          }
        />
      </Collapse>
      <List />
      <WebhookForm />
    </WebhookContext.Provider>
  );
}
